import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Menu',
        isTitle: true
    },
    {
        id: 2,
        label: 'set1.Common.Dashboard_brdcrmb',
        icon: 'bx bx-home-circle',
        link: '/',

    },

    {
        id: 2,
        label: 'set1.Operators.Title',
        icon: 'mdi mdi-database-lock-outline',
        link: '/operators',
    },
    {
        id: 2,
        label: 'Parking',
        icon: 'bx bx-car',
        link: '/parking',
    },
];

